export const CATEGORIES = [
  { key: 'betong', label: 'Betong', re: /betong|cement|ballast|hd\/f|platsgjut|prefab.*element|grout/ },
  { key: 'stal', label: 'Stål', re: /stål|armering|balk|pelare|hsq|plåtprofil|bult|peikko|ruukki|celsa/ },
  { key: 'tra', label: 'Trä', re: /trä|regel|virke|limträ|kerto|osb|plywood|läkt|råspont/ },
  { key: 'murning', label: 'Murning', re: /tegel|murbruk|lättbetong|block|puts|mur/ },
  { key: 'isolering', label: 'Isolering', re: /isoler|mineralull|cellplast|eps|xps|paroc|isover|stenull/ },
  { key: 'gips', label: 'Gips', re: /gips|spackel|skiva|norgips|gyproc/ },
  { key: 'tak', label: 'Tak', re: /tak|papp|takpann|takplåt|takduk|hängränna/ },
  { key: 'fonster', label: 'Fönster/Dörrar', re: /fönster|dörr|glas|parti|karm|elitfönster/ },
  { key: 'install', label: 'El & VVS', re: /el[\s-]|kabel|rör|vvs|ventil|brunn|avlopp|ledning|armatur|ahlsell|dahl/ },
  { key: 'ytskikt', label: 'Ytskikt', re: /golv|kakel|klinker|färg|målning|matta|parkett|tapet/ },
];

export const categoryOf = (m) => {
  const t = `${m.specific_product || m.name || ''} ${m.specification || ''}`.toLowerCase();
  const hit = CATEGORIES.find((c) => c.re.test(t));
  return hit ? hit.key : 'ovrigt';
};

export const CATEGORY_LABEL = Object.fromEntries([...CATEGORIES.map((c) => [c.key, c.label]), ['ovrigt', 'Övrigt']]);

export const groupByPhase = (materials) => {
  const map = new Map();
  materials.forEach((m, idx) => {
    const key = m.phase || 'Övrigt';
    if (!map.has(key)) map.set(key, { name: key, order: m.phase_order ?? 99, rows: [] });
    map.get(key).rows.push({ _idx: idx, ...m });
  });
  return [...map.values()].sort((a, b) => a.order - b.order);
};

export const sum = (rows) => rows.reduce((s, m) => s + (Number(m.estimated_total_price) || 0), 0);

const csvCell = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

export const materialsToCSV = (plan) => {
  const head = ['Byggdel', 'Material', 'Specifikation', 'Mängd', 'Enhet', 'Á-pris (kr)', 'Totalt (kr)', 'Spill %', 'Leverantör'];
  const rows = (plan.materials || []).map((m) => [m.phase, m.specific_product || m.name, m.specification, m.quantity, m.unit,
    m.estimated_unit_price, m.estimated_total_price, m.waste_pct, m.where_to_buy]);
  return '\uFEFF' + [head, ...rows].map((r) => r.map(csvCell).join(';')).join('\n');
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};
